module.exports = __webpack_public_path__ + "static/desktop-bycaliber-306153cbd29874474987aede799f0840.png";